import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectIsAdmin } from "../../store/authSelectors";

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  idParam?: string;
}

const ProtectedRoute = ({
  children,
  adminOnly = false,
  idParam = "id",
}: ProtectedRouteProps): React.ReactElement | null => {
  const params = useParams();
  const userIdFromUrl = params[idParam];
  const user = useAppSelector((state) => state.auth.user);
  const isAdmin = useAppSelector(selectIsAdmin);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (userIdFromUrl && !isAdmin && user.id !== userIdFromUrl) {
    return <Navigate to={`/users/${user.id}`} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to={`/users/${user.id}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
